

























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { fileApi } from "@/getinfo-api";
import CField from "@/components/form/CField.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: { CField, CustomButton, Modal, CustomTableCol, CustomTableItem }
})
export default class CFileManagerItem extends Vue {
  @Prop() item!: any;
  @Prop() moduleId!: string;
  @Prop({ default: false }) skeleton!: boolean;
  @Prop() isChooseSingleFile!: boolean;
  @Prop() isChecked!: boolean;
  @Prop({ default: false }) onlyTitle!: boolean;
  @Prop({ default: true }) isShowCopyAndViewIcon?: boolean;
  dotsMenu: boolean = false;
  localIsCheck: boolean = false;
  name: string = this.item.title;

  handleOutsideClick() {
    if (this.dotsMenu) {
      this.dotsMenu = false;
    }
  }

  get getIcon() {
    const formatImages = ["jpeg", "jpg", "png", "webp", "gif"];
    const formatVideo = ["mp4", "avi", "wmv"];
    if (this.item.type === "Directory") return "fas fa-folder";
    if (this.itemFormat === "doc" || this.itemFormat === "docx")
      return "fas fa-file-word";
    if (this.itemFormat === "pdf") return "fas fa-file-pdf";
    if (this.itemFormat === "ppt" || this.itemFormat === "pptx")
      return "fas fa-file-powerpoint";
    if (this.itemFormat === "xls" || this.itemFormat === "xlsx")
      return "fas fa-file-excel";
    if (formatImages.includes(this.itemFormat)) return "fas fa-file-image";
    if (formatVideo.includes(this.itemFormat)) return "fas fa-file-video";
    return "fas fa-file";
  }

  get screenWidth() {
    return this.$store.getters.SCREEN_WIDTH;
  }

  preShow() {
    this.$bvModal.show(this.item.id);
  }

  get iframeSrc() {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${
      this.item.url ? this.item.url : ""
    }`;
  }

  get preShowAvail() {
    const available: Array<string> = [
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "png",
      "pdf",
      "jpg",
      "gif",
      "webp",
      "svg",
      "mp4",
      "avi",
      "webm",
      "html"
    ];

    return available.includes(this.itemFormat);
  }

  get itemFormat() {
    if (this.item.type === "Directory") return "";
    return this.item.title.split(".").pop();
  }

  getFileSizeFormatter(bytes: number, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  action() {
    this.$emit("changeDirectory", this.item);
  }

  copyFile() {
    this.$emit("copy", this.item);
    this.dotsMenu = false;
  }

  renameFile() {
    let arrayPath = this.item.path.split("/");
    arrayPath.splice(-1);
    fileApi.FileApiV2.mv(this.$store.getters[`${this.moduleId}/GET_DISK_ID`], {
      src: this.item.path,
      dest: arrayPath?.length
        ? `${arrayPath.join("/")}/${this.name}`
        : this.name
    })
      .then((res: { data: any }) => {
        this.$store.commit(`${this.moduleId}/REMOVE_FILE`, res.data.id);
        this.$store.commit(`${this.moduleId}/ADD_FILES`, [res.data]);
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.dotsMenu = false;
      });
  }

  moveFile() {
    this.$store.commit(`${this.moduleId}/MOVE_FILE`, this.item);
    this.dotsMenu = false;
  }

  removeItem() {
    this.$emit("remove", this.item.id);
    this.dotsMenu = false;
  }

  copyLink() {
    try {
      navigator.clipboard.writeText(this.item.url);
    } catch (e) {
      throw e;
    }
    this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
      variant: "success",
      title: `${this.$tc(this.$translate.Success)}`
    });
  }

  @Watch("isChecked")
  checkProp() {
    this.localIsCheck = this.isChecked;
  }

  @Watch("localIsCheck")
  isCheckFile() {
    if (this.localIsCheck) {
      if (this.isChooseSingleFile) {
        this.$store.commit(`${this.moduleId}/CLEAR_CHECKED_FILES`);
        this.$store.commit(`${this.moduleId}/ADD_CHECKED_FILE`, this.item);
      } else {
        this.$store.commit(`${this.moduleId}/ADD_CHECKED_FILE`, this.item);
      }
    } else {
      this.$store.commit(
        `${this.moduleId}/REMOVE_FROM_CHECKED_FILE`,
        this.item
      );
    }
    this.$emit("checkChange");
  }
}
